import axios from './../plugins/private-api-axios'

export const vehicleService = {
    urlPrefix: '/vehicles',
    config: {
        headers: {
            Authorization: ''
        }
    },
    async createVehicle (
        vehicleFleetId,
        registrationNumber,
        manufacturer,
        model,
        fuelType,
        yearOfManufacture,
        mileage,
        engineSize,
        vehicleType
    ) {
        try {
            return await axios.post(this.urlPrefix, {
                vehicleFleetId: vehicleFleetId,
                registrationNumber: registrationNumber,
                manufacturer: manufacturer,
                model: model,
                fuelType: fuelType,
                yearOfManufacture: yearOfManufacture,
                mileage: mileage,
                engineSize: engineSize,
                vehicleType: vehicleType
            }, this.config)
        } catch (e) {
            throw e
        }
    },
    async getVehiclesBy (page, perPage, filter, value) {
        let urlBuilder = {
            'skip': (page - 1) * perPage,
            'take': perPage
        }

        if (null !== filter && null !== value) {
            urlBuilder[filter] = value
        }

        try {
            return await axios.get(`${this.urlPrefix}?${new URLSearchParams(urlBuilder).toString()}`, this.config)
        } catch (e) {
            if (409 === e.code) {
                e.message = 'Vehicle with this registration number already exist.'
            }

            throw e
        }
    },
    async getVehicleByUuid (uuid) {
        try {
            return await axios.get(`${this.urlPrefix}/${uuid}`, this.config)
        } catch (e) {
            throw e
        }
    },
    async editVehicle (
        uuid,
        vehicleFleetId,
        registrationNumber,
        manufacturer,
        model,
        fuelType,
        yearOfManufacture,
        mileage,
        engineSize,
        vehicleType
    ) {
        try {
            return await axios.put(`${this.urlPrefix}/${uuid}`, {
                vehicleFleetId: vehicleFleetId,
                registrationNumber: registrationNumber,
                manufacturer: manufacturer,
                model: model,
                fuelType: fuelType,
                yearOfManufacture: yearOfManufacture,
                mileage: mileage,
                engineSize: engineSize,
                vehicleType: vehicleType
            }, this.config)
        } catch (e) {
            if (409 === e.code) {
                e.message = 'Vehicle with this registration number already exist.'
            }

            throw e
        }
    },
    async deleteVehicle (uuid) {
        try {
            return await axios.delete(`${this.urlPrefix}/${uuid}`, this.config)
        } catch (e) {
            throw e
        }
    },
    async getVehicleForMap (fleetId) {
        try {
            return await axios.get(`${this.urlPrefix}/getAllVehiclesForMap?VehicleFleetId=${fleetId}`, this.config)
        } catch (e) {
            throw e
        }
    },
    async getVehicleForDashboard (fleetId) {
        try {
            return await axios.get(`${this.urlPrefix}/getAllVehiclesForDashboard?VehicleFleetId=${fleetId}`, this.config)
        } catch (e) {
            throw e
        }
    }
}

export const updateVehicleService = (accessToken) => {
    vehicleService.config.headers.Authorization = accessToken
}

export default vehicleService
